import { Maestro_ConfiguracionComercializacion } from "./Maestro_ConfiguracionComercializacion";
import { Maestro_ConfiguracionComercializacionDetalle } from './Maestro_ConfiguracionComercializacionDetalle';

export class MaestroConfiguracionComercializacionActualizacion {
    principal: Maestro_ConfiguracionComercializacion;
    listaDetalles: Maestro_ConfiguracionComercializacionDetalle[];
    listaDetallesEliminar: Maestro_ConfiguracionComercializacionDetalle[];
}